/** TanStack Query hook for the current authenticated user (GET /api/auth/me → { user, tenantId, role }) */

import { useQuery } from '@tanstack/react-query'
import { apiClient, ApiError } from '../lib/api-client'
import type { Role, User } from '@agentwiki/shared'

export type CurrentUser = Pick<User, 'id' | 'email' | 'name' | 'avatarUrl'>

interface MeResponse {
  user: CurrentUser
  tenantId: string
  role: Role
}

export function useAuth() {
  const query = useQuery<MeResponse, ApiError>({
    queryKey: ['auth', 'me'],
    queryFn: () => apiClient.get<MeResponse>('/api/auth/me'),
    retry: false,
    staleTime: 1000 * 60 * 5, // 5 minutes
  })

  return {
    user: query.data?.user ?? null,
    role: query.data?.role ?? null,
    tenantId: query.data?.tenantId ?? null,
    isLoading: query.isLoading,
    isAuthenticated: !!query.data?.user,
    error: query.error,
    refetch: query.refetch,
  }
}
